import { Typography } from '@mui/material';

import useTimeAgo from '@frontend/features/common/hooks/useTimeAgo';
import { useTwilio } from '@frontend/features/communications/TwilioContextProvider/provider';

const CallDuration = () => {
  const { callDuration } = useTwilio();
  const duration = useTimeAgo(callDuration);

  return (
    <Typography color="primary.contrastText" variant="h6" align="center" sx={{ mb: 2 }}>
      {duration || '00:00'}
    </Typography>
  );
};

export default CallDuration;
